import { useState, useEffect } from "react";
import { apiBuyerDetail, BuyerDetailResponse } from "@/service/api";
import jsCookie from 'js-cookie'
import { TOKEN_KEY, BUYER_INFO_KEY } from "@/constants";

export default () => {
  const [user, setUser] = useState<BuyerDetailResponse | null>(() => {
    try {
      return JSON.parse(localStorage.getItem(BUYER_INFO_KEY) || 'null')
    } catch (error) {
      return null
    }
  })

  const getUser = async () => {
    try {
      const res = await apiBuyerDetail({});
      if (res.code === 0) {
        setUser(res.data);
        localStorage.setItem(BUYER_INFO_KEY, JSON.stringify(res.data));
      }
    } catch (error) {

    }
  }

  const signIn = (user: BuyerDetailResponse) => {
    setUser(user)
  }

  const logOut = () => {
    jsCookie.remove(TOKEN_KEY)
    localStorage.removeItem(BUYER_INFO_KEY)
    window.location.replace(`${window.location.protocol}//${window.location.host+ '/'}`)
  }

  useEffect(() => {
    try {
      const token = jsCookie.get(TOKEN_KEY)
      if (token) {
        getUser();
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  return {
    user,
    getUser,
    logOut,
    signIn,
  }
}